import React from 'react';
import PropTypes from 'prop-types';

function ResponsiveImage({ src, maxHeight, alt }) {
  return (
    <img
      src={src}
      alt={alt}
      style={{
        width: '100%',
        maxHeight: `${maxHeight}px`,
        objectFit: 'contain',
      }}
    />
  );
}

ResponsiveImage.propTypes = {
  src: PropTypes.string.isRequired,
  maxHeight: PropTypes.number.isRequired,
  alt: PropTypes.string,
};

ResponsiveImage.defaultProps = {
  alt: '',
};

export default ResponsiveImage;
